/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientCommonExpression } from './PatientCommonExpression';
import {
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionFromJSONTyped,
    PatientCommonExpressionToJSON,
    PatientCommonExpressionToJSONTyped,
} from './PatientCommonExpression';
import type { DoseTimingResponseConceptGroup } from './DoseTimingResponseConceptGroup';
import {
    DoseTimingResponseConceptGroupFromJSON,
    DoseTimingResponseConceptGroupFromJSONTyped,
    DoseTimingResponseConceptGroupToJSON,
    DoseTimingResponseConceptGroupToJSONTyped,
} from './DoseTimingResponseConceptGroup';

/**
 * 
 * @export
 * @interface DoseTimingResponse
 */
export interface DoseTimingResponse {
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    updated?: string;
    /**
     * 
     * @type {number}
     * @memberof DoseTimingResponse
     */
    expressionId?: number;
    /**
     * 
     * @type {number}
     * @memberof DoseTimingResponse
     */
    doseTimingId?: number;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    timelineStart?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    timelineEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    languageIso?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    originalPosologie?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    originalDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    conceptTimingType?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    administrationTimingType?: string;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    administrationDateTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    sctAdministrationPeriod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DoseTimingResponse
     */
    sctAdministrationFrequency?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DoseTimingResponse
     */
    asRequired?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DoseTimingResponse
     */
    sequenceOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof DoseTimingResponse
     */
    days?: number;
    /**
     * 
     * @type {DoseTimingResponseConceptGroup}
     * @memberof DoseTimingResponse
     */
    conceptGroup?: DoseTimingResponseConceptGroup;
    /**
     * 
     * @type {number}
     * @memberof DoseTimingResponse
     */
    definingSapExpressionId?: number;
    /**
     * 
     * @type {PatientCommonExpression}
     * @memberof DoseTimingResponse
     */
    closestExpression?: PatientCommonExpression;
}

/**
 * Check if a given object implements the DoseTimingResponse interface.
 */
export function instanceOfDoseTimingResponse(value: object): value is DoseTimingResponse {
    return true;
}

export function DoseTimingResponseFromJSON(json: any): DoseTimingResponse {
    return DoseTimingResponseFromJSONTyped(json, false);
}

export function DoseTimingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoseTimingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'expressionId': json['expressionId'] == null ? undefined : json['expressionId'],
        'doseTimingId': json['doseTimingId'] == null ? undefined : json['doseTimingId'],
        'timelineStart': json['timelineStart'] == null ? undefined : json['timelineStart'],
        'timelineEnd': json['timelineEnd'] == null ? undefined : json['timelineEnd'],
        'languageIso': json['languageIso'] == null ? undefined : json['languageIso'],
        'originalPosologie': json['originalPosologie'] == null ? undefined : json['originalPosologie'],
        'originalDuration': json['originalDuration'] == null ? undefined : json['originalDuration'],
        'conceptTimingType': json['conceptTimingType'] == null ? undefined : json['conceptTimingType'],
        'administrationTimingType': json['administrationTimingType'] == null ? undefined : json['administrationTimingType'],
        'administrationDateTime': json['administrationDateTime'] == null ? undefined : json['administrationDateTime'],
        'sctAdministrationPeriod': json['sctAdministrationPeriod'] == null ? undefined : json['sctAdministrationPeriod'],
        'sctAdministrationFrequency': json['sctAdministrationFrequency'] == null ? undefined : json['sctAdministrationFrequency'],
        'asRequired': json['asRequired'] == null ? undefined : json['asRequired'],
        'sequenceOrder': json['sequenceOrder'] == null ? undefined : json['sequenceOrder'],
        'days': json['days'] == null ? undefined : json['days'],
        'conceptGroup': json['conceptGroup'] == null ? undefined : DoseTimingResponseConceptGroupFromJSON(json['conceptGroup']),
        'definingSapExpressionId': json['definingSapExpressionId'] == null ? undefined : json['definingSapExpressionId'],
        'closestExpression': json['closestExpression'] == null ? undefined : PatientCommonExpressionFromJSON(json['closestExpression']),
    };
}

export function DoseTimingResponseToJSON(json: any): DoseTimingResponse {
    return DoseTimingResponseToJSONTyped(json, false);
}

export function DoseTimingResponseToJSONTyped(value?: DoseTimingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'],
        'updated': value['updated'],
        'expressionId': value['expressionId'],
        'doseTimingId': value['doseTimingId'],
        'timelineStart': value['timelineStart'],
        'timelineEnd': value['timelineEnd'],
        'languageIso': value['languageIso'],
        'originalPosologie': value['originalPosologie'],
        'originalDuration': value['originalDuration'],
        'conceptTimingType': value['conceptTimingType'],
        'administrationTimingType': value['administrationTimingType'],
        'administrationDateTime': value['administrationDateTime'],
        'sctAdministrationPeriod': value['sctAdministrationPeriod'],
        'sctAdministrationFrequency': value['sctAdministrationFrequency'],
        'asRequired': value['asRequired'],
        'sequenceOrder': value['sequenceOrder'],
        'days': value['days'],
        'conceptGroup': DoseTimingResponseConceptGroupToJSON(value['conceptGroup']),
        'definingSapExpressionId': value['definingSapExpressionId'],
        'closestExpression': PatientCommonExpressionToJSON(value['closestExpression']),
    };
}

